import { PropsWithChildren } from 'react';
import styles from './AssetWidget.module.scss';

export interface AssetWidgetProps {
  title: string;
  width?: string;
  alignEnd?: boolean;
  isCompact?: boolean;
  textAlign?: 'left' | 'right';
}

export function AssetWidget({
  title,
  width,
  alignEnd = false,
  isCompact = false,
  textAlign,
  children,
}: PropsWithChildren<AssetWidgetProps>) {
  return (
    <div
      className={`${styles.metric} ${typeof width === 'undefined' && styles['metric--flexgrow']} ${alignEnd && styles['metric--flexend']} ${textAlign && styles[`metric--${textAlign}`]}`}
    >
      <div
        className={`${styles.metric__title} ${isCompact && styles['metric__title--compact']}`}
        style={{ width: width }}
      >
        {title}
      </div>
      <div className={styles.metric__keyValue}>{children}</div>
    </div>
  );
}

export default AssetWidget;
